/**
 * De-serializes the locales data fetched from layout phoenix into the format used by this package.
 * @param {Locale[]} locales A list of all supported locales.
 * @return {String[]}
 */
export const deserializeLocales = (locales = []) => locales.map(({ iso_code }) => iso_code);
